module.exports = __webpack_public_path__ + "static/media/mail.e886f956.svg";